import React,{ useState, useEffect } from 'react';

import { Box, Button } from '@mui/material';
import { Dialog, DialogTitle, DialogContent, DialogActions, TextField, MenuItem } from '@mui/material';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

import { Row, Col } from 'antd';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import Stack from '@mui/material/Stack';
import DynamicTable from '../Reusable/DynamicTable';
import axios from 'axios';
import CustomTextField from "../Reusable/Numerictext";
import Swal from 'sweetalert2';
import CustomButton from '../Reusable/CustomButton';
import { SelectNormal, SelectSearch, MultipleSelect } from '../Reusable/SelectBox';
import { useNavigate } from "react-router-dom";
import { BASE_URL } from "../../App";
import {Backdrop, CircularProgress, } from '@mui/material';


const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};


const Example = () => {
    const navigate = useNavigate();
    const [validationErrors, setValidationErrors] = useState({});
    const [editedRowData, setEditedRowData] = useState(null);
    const [isCreateUserPopupOpen, setCreateUserPopupOpen] = useState(false);
    const [editingRow, setEditingRow] = useState(null);
    const [viewData, setViewedData] = useState(null);
    const [isViewPopupOpen, setViewPopupOpen] = useState(false);
    const [branchList, setBranchList] = useState([]);
    const [CATEGORY, setCATEGORY] = useState([]);
    const [isStartDayEntered, setIsStartDayEntered] = useState(false);
    const [isError, setIsError] = useState(false);
    const [loading, setloading] = React.useState(false);

    var LOGINID = localStorage.getItem('LOGIN_ID')
    //  const { data: fetchedUsers = [], isError: isLoadingUsersError, isFetching: isFetchingUsers, isLoading: isLoadingUsers } = useGetUsers();
    const handleCreateUser = async ({ values, row, table }) => {
        console.log('New User Entered values:', values);
        setValidationErrors({});
        fetchData();
        //table.setCreatingRow(null);
    };

    const handleSaveUser = async ({ values, table }) => {
        setValidationErrors({});
        table.setEditingRow(null);
        fetchData();

    };
    const handleView = (row) => {
        setViewedData(row.original);
        setViewPopupOpen(true);
    };
    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await axios.post(BASE_URL + '/monthlyplanorderconfigurationforcreate'
                    //login_id: 'admin'
                );

                const responseData = response.data;

                // Extract branch list
                const branch = responseData.branchlist || [];
                console.log("Branch List:", branch);
                setBranchList(branch);

                // Extract function name list
                const Categorycode = responseData.dealercategorylist || [];
                console.log("CATEGORY:", Categorycode);
                setCATEGORY(Categorycode);

            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };

        fetchData();
    }, []);

    const ViewDataPopup = ({ data, onClose }) => {
        return (
            <Dialog open={true} onClose={onClose} maxWidth="sm" fullWidth>
                <DialogTitle><u><b>View Configuration</b></u></DialogTitle>
                <DialogContent>
                    <Row>
                        <Col xs={22} sm={10}>
                            <TextField label="Branch" fullWidth value={data.BRANCH_NAME} margin="normal" InputProps={{ readOnly: true, }} />
                        </Col>
                        <Col xs={4} sm={2}></Col>
                        <Col xs={22} sm={10}>
                            <TextField label="Category" fullWidth value={data.CATEGORY} margin="normal" InputProps={{ readOnly: true, }} />
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={22} sm={10}>
                            <TextField label="Start Day" fullWidth value={data.START_DAY} margin="normal" InputProps={{ readOnly: true, }} />
                        </Col>
                        <Col xs={4} sm={2}></Col>
                        <Col xs={22} sm={10}>
                            <TextField label="End Day" fullWidth value={data.END_DAY} margin="normal" InputProps={{ readOnly: true, }} />
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={22} sm={10}>
                            <TextField label="Min. Order Value" fullWidth value={data.MIN_ORDER_VALUE} margin="normal" InputProps={{ readOnly: true, }} />
                        </Col>
                        <Col xs={4} sm={2}></Col>
                        <Col xs={22} sm={10}>
                            <TextField label="Deviation" fullWidth value={data.DEVIATION} margin="normal" InputProps={{ readOnly: true, }} />
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={22} sm={10}>
                            <TextField label="Payment Due Days" fullWidth value={data.PAYMENT_DUE_DAYS} margin="normal" InputProps={{ readOnly: true, }} />
                        </Col>
                        <Col xs={4} sm={2}></Col>
                        <Col xs={22} sm={10}>
                            {/* <TextField label="branch" fullWidth value={data.DEVIATION} margin="normal" InputProps={{ readOnly: true, }} /> */}
                        </Col>
                    </Row>
                </DialogContent>
                <DialogActions style={{ justifyContent: 'center' }}>
                    <CustomButton
                        label="CLOSE"
                        onClick={onClose}
                        variant="outlined"
                        // color="error"
                        fullWidth
                        width="200px"
                    // height={40}
                    // borderRadius="8px"
                    />
                    {/* <Button 
        onClick={onClose} 
        size="medium" variant="outlined" color="error" sx={{ flexGrow: 1 }}// Set the width to 100%
    > 
        Close
     </Button> */}
                </DialogActions>

            </Dialog>


        );
    };

    const EditUserPopup = ({ user, onSave, onClose }) => {
        const [editedUser, setEditedUser] = useState({ ...user });
        const [Errormsg, setErrormsg] = useState('');
        const data = {
            branch_code: editedUser.CODE,
            category_code: editedUser.CATEGORY,
            start_date: editedUser.START_DAY,
            end_date: editedUser.END_DAY,
            min_order_value: editedUser.MIN_ORDER_VALUE,
            datatransferflag: 'N',
            localdatatransferflag: 'N',
            deviation: editedUser.DEVIATION,
            payment_due_days: editedUser.PAYMENT_DUE_DAYS,
            login_id: LOGINID

        };
        const update = {
            branch_code: editedUser.CODE,
            category_code: editedUser.CATEGORY,
            start_date: editedUser.START_DAY,
            end_date: editedUser.END_DAY,
            min_order_value: editedUser.MIN_ORDER_VALUE,
            deviation: editedUser.DEVIATION,
            payment_due_days: editedUser.PAYMENT_DUE_DAYS,
            login_id: LOGINID
            // other properties...
        };
        const handleChange = (fieldName) => (event) => {
            const value = event.target.type === 'checkbox' ? event.target.checked : event.target.value;
            setEditedUser((prev) => ({ ...prev, [fieldName]: value }));
            setInputs((prevInputs) => ({ ...prevInputs, [event.target.name]: event.target.value }));
            if (fieldName === 'Active' || fieldName === 'VALUEBASED') {
                setEditedUser((prevEditedUser) => ({
                    ...prevEditedUser,
                    [fieldName]: value ? 1 : 0,
                }));
            }
        };
        const validateInput = () => {
            if (!editedUser.CODE || !editedUser.CATEGORY || !editedUser.START_DAY || !editedUser.END_DAY || !editedUser.MIN_ORDER_VALUE || !editedUser.DEVIATION || !editedUser.PAYMENT_DUE_DAYS) {
               setErrormsg('Please fill in all fields!');
                return false;
            }
            return true;
            
        };
        const [inputs, setInputs] = useState({
            CODE: '', CATEGORY: '', START_DAY: '', END_DAY: '', MIN_ORDER_VALUE: '', DEVIATION: '', PAYMENT_DUE_DAYS: '', datatransferflag: '',
            localdatatransferflag: ''
        });
        const handleSave = async (e) => {
            e.preventDefault(); 
            if (!validateInput()) {
                 return ;
             }
            

            try {
                let response;
                if (user) {
                    if (data.start_date > data.end_date) {
                        setErrormsg('The start day should be before the end day.');
                        return false;
                    } else {
                        response = await axios.post(BASE_URL + '/monthlyplanorderconfigurationupdate', update);
                        if (response.data.status_code == '400') {
                            // Swal.fire({
                            //     allowOutsideClick: false,
                            //     position: 'top-end',
                            //     icon: 'error',
                            //     title: 'Error',
                            //     text: 'Data Already Entered',
                            //     timer: 3000,
                            //     showConfirmButton: false,
                            //     timerProgressBar: true,
                            //     customClass: {
                            //         popup: 'custom-popup-class',
                            //     },
                           // });
                           setErrormsg('These Data is Already Exist');
                            return false;;
                        }
                        else if(response.data.status_code == '200') {

                            Swal.fire({
                                icon: 'success',
                                text: response.data.text || 'Data saved successfully!',
                            });
                        }
                    }

                } else {
                    if (data.start_date > data.end_date) {
                        setErrormsg('The start day should be before the end day.');
                        return false;
                    } else {
                        response = await axios.post(BASE_URL + '/monthlyplanorderconfigurationcreate', data);
                        if (response.data.status_code == '400') {
                            // Swal.fire({
                            //     allowOutsideClick: false,
                            //     position: 'top-end',
                            //     icon: 'error',
                            //     title: 'Error',
                            //     text: 'Data Already Entered',
                            //     timer: 3000,
                            //     showConfirmButton: false,
                            //     timerProgressBar: true,
                            //     customClass: {
                            //         popup: 'custom-popup-class',
                            //     },
                           // });
                           setErrormsg('These Data is Already Exist');
                            return false;;
                        }
                        else if(response.data.status_code == '200') {

                            Swal.fire({
                                icon: 'success',
                                text: response.data.text || 'Data saved successfully!',
                            });
                        }
                    }
                }

                Swal.fire({
                    icon: 'success',
                    text: response.data.text || 'Data Updated successfully!',
                });
            } catch (error) {
                console.error('Error inserting data:', error);
                if (error.response) {
                    const errorMessages = error.response.data.message;
                    const errorMessageList = errorMessages.map((message, index) => `${index + 1}. ${message}`).join('\n');
                   setErrormsg('*Please Fill in All Fields');
                    return false;
                }
                else if (error.request) {
                    // Swal.fire({
                    //     icon: 'error',
                    //     title: 'Error',
                    //     text: 'No response received from the server.',
                    // });
                    setErrormsg('*Please Fill in All Fields');
                } else {
                    Swal.fire({
                        icon: 'error',
                        title: 'Error',
                        text: 'Error setting up the request. Please try again.',
                    });
                }
            }
            //onSave(editedUser);
            onClose();
        };

        const BRANCH_NAME = branchList ? branchList.map((branchItem) => ({
            Value: branchItem.CODE,
            Label: branchItem.name,
        })) : [];

        const CATEGORY_LIST = CATEGORY ? CATEGORY.map((branchItem) => ({
            Value: branchItem.CATEGORY,
            Label: branchItem.CATEGORY,
            // Index: branchItem.CATEGORY,
        })) : [];

        {
            CATEGORY.map((branchItem) => (
                <MenuItem key={branchItem.CATEGORY} value={branchItem.CATEGORY}>
                    {branchItem.CATEGORY}
                </MenuItem>
            ))
        }

        return (

            <Dialog open={true} onClose={onClose} maxWidth="sm" fullWidth >
                <DialogTitle>
                    <u>
                        <b>{user ? 'Edit Configuration' : 'Create New Configuration'}</b>
                    </u>
                </DialogTitle>
                <DialogContent>
                    <Row>
                        <Col xs={22} sm={10}>
                            {!!user ? (
                                <SelectNormal
                                    readOnly={true}
                                    label="BRANCH NAME"
                                    options={BRANCH_NAME}
                                    value={editedUser.CODE}
                                    onChange={(e) => setEditedUser({ ...editedUser, CODE: e.target.value })}
                                />
                            ) : (
                                <SelectSearch
                                    label="BRANCH NAME"
                                    options={BRANCH_NAME}
                                    value={editedUser.CODE}
                                    onChange={(newValue) => setEditedUser({ ...editedUser, CODE: newValue })}
                                />
                            )}

                        </Col>
                        <Col xs={4} sm={2}></Col>
                        <Col xs={22} sm={10}>

                            {!!user ? (
                                <SelectNormal
                                    readOnly={true}
                                    label="CATEGORY"
                                    name="CATEGORY"
                                    options={CATEGORY_LIST}
                                    value={editedUser.CATEGORY}
                                    onChange={(e) => setEditedUser({ ...editedUser, CATEGORY: e.target.value })}
                                />
                            ) : (
                                <SelectSearch
                                    label="CATEGORY"
                                    name="CATEGORY"
                                    options={CATEGORY_LIST}
                                    value={editedUser.CATEGORY}
                                    onChange={(newValue) => setEditedUser({ ...editedUser, CATEGORY: newValue })}
                                />
                            )}


                        </Col>
                    </Row>
                    <Row>
                        <Col xs={22} sm={10}>
                            <CustomTextField
                                label="START DAY"
                                name="START_DAY"
                                type="number"
                                value={editedUser.START_DAY}
                                onChange={(e) => {
                                    const newValue = Math.min(31, Math.max(0, parseInt(e.target.value))); // Ensure value is between 0 and 31
                                    setEditedUser({ ...editedUser, START_DAY: newValue });
                                }}
                                inputProps={{ min: "0", max: "31" }}
                            />
                        </Col>
                        <Col xs={4} sm={2}></Col>
                        <Col xs={22} sm={10}>
                            <CustomTextField
                                label="END DAY"
                                name="END_DAY"
                                type="number"
                                value={editedUser.END_DAY}
                                onChange={(e) => {
                                    const newValue = Math.min(31, Math.max(0, parseInt(e.target.value))); // Ensure value is between 0 and 31
                                    setEditedUser({ ...editedUser, END_DAY: newValue });
                                }}
                                inputProps={{ min: "0", max: "31" }}
                            />
                        </Col>
                    </Row>

                    <Row>
                        <Col xs={22} sm={10}>
                            <CustomTextField
                                label="MINIMUM ORDER VALUE"
                                name="MIN_ORDER_VALUE"
                                type="number"
                                maxLength="3"
                                value={editedUser.MIN_ORDER_VALUE}
                                onChange={(e) => {
                                    const inputValue = e.target.value.trim();
                                    if (inputValue === '' || (!isNaN(inputValue) && parseInt(inputValue) >= 1)) {
                                        setEditedUser({ ...editedUser, MIN_ORDER_VALUE: inputValue });
                                    }

                                }}
                                inputProps={{ min: "1" }}

                            >
                            </CustomTextField>
                        </Col>
                        <Col xs={4} sm={2}></Col>
                        <Col xs={22} sm={10}>
                            <CustomTextField
                                label="DEVIATION (%)"
                                name="DEVIATION"
                                type="number"
                                value={editedUser.DEVIATION}
                                onChange={(e) => {
                                    const newValue = Math.min(100, Math.max(0, parseInt(e.target.value))); // Ensure value is between 0 and 100
                                    setEditedUser({ ...editedUser, DEVIATION: newValue });
                                }}
                                inputProps={{ min: "0", max: "100" }}
                            />


                        </Col>
                    </Row>
                    <Row>
                        <Col xs={22} sm={10}>
                            <CustomTextField
                                label="PAYMENT DUE DAYS"
                                name="PAYMENT_DUE_DAYS"
                                maxLength="3"
                                type="number"
                                value={editedUser.PAYMENT_DUE_DAYS}
                                onChange={(e) => {
                                    const newValue = Math.max(0, parseInt(e.target.value)); // Ensure value is not negative
                                    setEditedUser({ ...editedUser, PAYMENT_DUE_DAYS: newValue });
                                }}
                                inputProps={{ min: "0" }}
                            />


                        </Col>
                        {/* {/* <Col xs={4} sm={2}></Col>
                  <Col xs={22} sm={10}> 
                  </Col> */}
                    </Row>
                    {Errormsg &&(
               
                    <p style={{ color: "red" }}><b><h6>*{Errormsg}</h6></b></p>
                )}
                    {/* <center>
                        <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                            <div style={{ display: 'flex', justifyContent: 'center' }}>

                                <br />
                            </div>
                        </Typography>
                    </center> */}
                </DialogContent>
                <DialogActions sx={{ justifyContent: 'center' }}>
                    <Stack direction="row" spacing={2} sx={{ width: '100%', maxWidth: '400px' }}>
                        <CustomButton
                            label={user ? 'Save' : 'Create'}
                            onClick={(e) => handleSave(e)}
                            variant="outlined"
                            size="medium"
                            height={40}
                            width="200px"
                            borderRadius="8px"
                            // type="submit"
                            sx={{ flexGrow: 1 }}
                        />
                        <CustomButton
                            label="Cancel"
                            onClick={onClose}
                            variant="outlined"
                            size="medium"
                            height={40}
                            width="200px"
                            borderRadius="8px"
                            sx={{ flexGrow: 1 }}
                            color="error"
                        />
                    </Stack>
                </DialogActions>
            </Dialog>

        );
    };
    const [tableData, setTableData] = useState([]);
    // const [Errormsg, setErrormsg] = useState('');
    const fetchData = () => {

            setloading(true);

        axios.post(BASE_URL + '/monthlyplanorderconfigurationlist')
            // .then(response => setTableData(response.data.monthlyplanorderconfigurationlist))
            // .catch(error => console.error('Error fetching data:', error));
            .then(response => {
           
                if (response.status === 200) {
            
                    setTableData(response.data.monthlyplanorderconfigurationlist);
                    setloading(false);
                } else {
                    setloading(false);
                    console.error('Unexpected status code:', response.status);
                    Swal.fire({
                        icon: "warning",
                        text: 'Unexpected response status. Please try again.'
                    });
                }
            })
            .catch(error => {
                // Handle errors here
                console.error('Error:', error);

                // Check if the error has a response
                if (error.response) {
                    // The request was made, but the server responded with a status code
                    // that falls out of the range of 2xx
                    console.error('Error response status:', error.response.status);
                    console.error('Error response data:', error.response.data);

                    // Display an alert with the error message
                    Swal.fire({
                        icon: "warning",
                        text: `Error: ${error.response.data.message}`
                    });
                } else if (error.request) {
                    // The request was made, but no response was received
                    console.error('No response received');
                } else {
                    // Something happened in setting up the request that triggered an Error
                    console.error('Error setting up the request:', error.message);
                }
            });

        // }, []);
    }

    const Branch_code = localStorage.getItem("BRANCH_CODE");
    const login_id = localStorage.getItem("LOGIN_ID");

    useEffect(() => {
        if (!login_id || !Branch_code) {
            Swal.fire({
                icon: "warning",
                text: 'Login Failed !'
            });
            localStorage.clear()
            navigate('/')
            navigate('/Login')
        } else {
            fetchData();
        }
    }, []);
    const openCreateUserPopup = (rowData) => {

        // alert(`Edited Row Data: ${JSON.stringify(rowData)}`);
        setCreateUserPopupOpen(true);
        setEditedRowData(rowData);
    };
    const handleViewEditClick = (rowData) => {

        setViewedData(rowData);
        setViewPopupOpen(true);
    };
    return (
        <>
            <DynamicTable data={tableData} onEditClick={openCreateUserPopup} onViewClick={handleViewEditClick} />;

            {editingRow && (

                <EditUserPopup
                    user={editingRow.original}
                    onSave={(editedData) => {
                        handleSaveUser({ values: editedData, tableData });
                    }}
                    onClose={() => setEditingRow(null)}
                />
            )}
            {isCreateUserPopupOpen && (

                <EditUserPopup
                    user={editedRowData}
                    onSave={handleCreateUser}
                    onClose={() => {
                        setCreateUserPopupOpen(false);
                        setEditedRowData(null); // Clear the edited row data when closing the popup
                    }}
                />
            )}
            {isViewPopupOpen && (
                <ViewDataPopup
                    data={viewData}
                    onClose={() => setViewPopupOpen(false)}
                />
            )}

<Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={loading} >
            <CircularProgress color="inherit" />
          </Backdrop>

        </>
    );
};

const queryClient = new QueryClient();

const ExampleWithProviders = () => (
    <QueryClientProvider client={queryClient}>
        <Example />
    </QueryClientProvider>
);

export default ExampleWithProviders;